import { Dispatch, SetStateAction } from 'react';
import { ONE_GB_IN_BYTES } from '../../constants';
import { isImage } from './file';
import { FileUploadError } from '../types/Upload';

export const testImage = (img: Blob | File) =>
    new Promise<boolean>((resolve) => {
        const tester = new Image();
        tester.onerror = () => resolve(false);
        tester.onload = () => resolve(true);
        tester.src = URL.createObjectURL(img);
    });

export const getIsMimeTypeAllowed = (file: File, allowedMimetypes: string[]) => {
    const fileType = file.type.split('/')[0];
    const isAllowed = allowedMimetypes.some((mimetype) => mimetype.includes(fileType));
    return isAllowed;
};

export const validateFile = async (
    file: File,
    currentFilesTotalSize: number,
    allowedMimetypes: string[],
    setErrorMessage: Dispatch<SetStateAction<FileUploadError | undefined>>
) => {
    // check if image itself has an error
    const isWithoutError = isImage(file) ? await testImage(file) : true;
    // superficially check if file type is allowed for this upload
    const isAllowed = getIsMimeTypeAllowed(file, allowedMimetypes);
    /* check if file size is within limits, total size of all files should be <= 1GB
       but this limit is very conservative, because all images are compressed in BE (STRAPI Image Upload ships with compression feature)
    */

    const isSizeOk = currentFilesTotalSize + file.size <= ONE_GB_IN_BYTES;

    if (isAllowed && isWithoutError && isSizeOk) {
        return true;
    } else {
        // only one error message will be set at the end, order is prioritized
        !isSizeOk && setErrorMessage(FileUploadError.FILE_SIZE);
        !isAllowed && setErrorMessage(FileUploadError.FILE_TYPE);
        !isWithoutError && setErrorMessage(FileUploadError.IMAGE_ERROR);
        return false;
    }
};
